import { useMemo } from 'react';

import WordIcon from './icon/04_056.svg';
import PdfIcon from './icon/04_059.svg';
import OtherIcon from './icon/04_061.svg';
import SheetIcon from './icon/04_198.svg';
import LinkIcon from './icon/link.svg';

interface Props {
  fileName?: string;
  type?: 'website' | 'file';
}

const fileMedia: any = {
  pdf: {
    component: PdfIcon,
    type: ['pdf'],
  },
  word: {
    component: WordIcon,
    type: ['doc', 'docx', 'rtf'],
  },
  excel: {
    component: SheetIcon,
    type: ['xls', 'xlsx', 'csv'],
  },
  text: {
    component: OtherIcon,
    type: ['txt', 'md', 'html', 'htm', 'shtml', 'ehtml', 'shtm', 'text'],
  },
  url: {
    component: LinkIcon,
    type: [],
  },
  other: {
    component: OtherIcon,
    type: [],
  },
};

export default ({ fileName, type }: Props) => {
  if (type === 'website') return <img src={fileMedia['url'].component} />;

  const fileSuffix = useMemo(() => {
    if (!fileName) return '';
    const suffiix = fileName.split('.').pop();
    return suffiix ? suffiix.toLocaleLowerCase() : 'other';
  }, [fileName]);

  const fileMediaKey = useMemo(() => {
    let key = 'other';
    Object.keys(fileMedia).forEach((k) => {
      if (fileMedia[k].type.indexOf(fileSuffix) !== -1) {
        key = k;
      }
    });
    return key;
  }, [fileSuffix]);

  return <img src={fileMedia[fileMediaKey].component} />;
};
